import template from './adpHoverTooltip.html';
import controller from './adpHoverTooltip.controller';
import './adpHoverTooltip.less';

let adpHoverTooltipComponent = {
  restrict: 'E',
  bindings: {},
  template,
  transclude: {
    content: "?hoveredElement",
    message: "?tooltipMsg"
  },
  controller
};

export default adpHoverTooltipComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpHoverTooltip/adpHoverTooltip.component.js